import { grayColor } from 'assets/jss/material-dashboard-pro-react';

const deviceCardStyles = (theme) => ({
	container: {
		display: 'flex',
		minHeight: '300px',
		backgroundColor: grayColor[1],
		margin: '0 60px 20px 60px',
		borderRadius: '15px',
		padding: '15px',

		[theme.breakpoints.down('xs')]: {
			display: 'block',
		},
	},

	image: {
		width: '75px',
		height: '110px',
	},

	photoContainer: {
		flex: 1,
		justifyContent: 'center',
		display: 'flex',
		[theme.breakpoints.down('xs')]: {
			display: 'block',
			marginBottom: '30px',
		},
	},
	contentContainer: {
		flex: 2,
		display: 'flex',
		flexDirection: 'column',
	},

	storage: {
		margin: '15px 0',
	},

	color: {
		margin: '15px 0',
	},

	description: {
		margin: '0 0 15px 0',
		'& p': {
			fontSize: '11px',
		},
	},

	bold: {
		display: 'inline-block',
		'& p': {
			fontWeight: 'bold',
			fontSize: '11px',
		},
	},

	divider: {
		display: 'block',
		width: '100%',
		height: '1px',
		margin: '10px 0',
		backgroundColor: grayColor[8],
	},
});

export default deviceCardStyles;
